import { getBackgroundCSS, getBorderCSS, getShadowCSS, getSpaceCSS, getTypoCSS } from '../../Components/Helper/getCSS';

const Style = ({ attributes, clientId }) => {
	const { boxPosition, width, background, padding, shadow, alignment, boxBG, boxWidth, boxHeight, boxSpace, boxBorder, boxShadow, digitTypo, digitColor, labelTypo, labelColor, sepType, sepSize, sepColor } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${getTypoCSS(digitTypo)?.googleFontLink}
		${getTypoCSS(labelTypo)?.googleFontLink}

		#ctbCountdownTime-${clientId}{
			align-items: ${alignment};
			justify-content: ${alignment};
		}
		#ctbCountdownTime-${clientId} .countdownItems{
			gap: ${boxSpace};
			width: ${'0px' === width || '0%' === width || '0em' === width ? 'auto' : width};
			${getBackgroundCSS(background)}
			padding: ${getSpaceCSS(padding)};
			box-shadow: ${getShadowCSS(shadow)};
			justify-content: ${boxPosition};
		}
		#ctbCountdownTime-${clientId} .countdownItems .countdownItem{
			${getBackgroundCSS(boxBG)}
			width: ${boxWidth};
			height: ${boxHeight};
			${getBorderCSS(boxBorder)}
			box-shadow: ${getShadowCSS(boxShadow)};
		}
		#ctbCountdownTime-${clientId} .countdownItems .separator::before{
			content: '${sepType}';
			font-size: ${sepSize}px;
			color: ${sepColor};
		}
		#ctbCountdownTime-${clientId} .countdownItems .countdownItem .digit{
			color: ${digitColor};
			${getTypoCSS(digitTypo)?.styles}
		}
		#ctbCountdownTime-${clientId} .countdownItems .countdownItem .label{
			color: ${labelColor};
			${getTypoCSS(labelTypo)?.styles}
		}
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;